export default __webpack_public_path__ + "static/media/LAS0150.34I-30435_-21724_0.1cb9e8a8.jpg";